(function () {
/*
  * -----------------------------------------------------------------------------
  * @cam/details-accordion-multistep
  * -----------------------------------------------------------------------------
  * @version 0.0.1
  * @overview Procedural step collapsible accordions.
  * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
  * -----------------------------------------------------------------------------
  * @requires @cam/details-accordion
  * -----------------------------------------------------------------------------
*/ if (customElements.get("details-accordion-multistep") === undefined) {
    class DetailsAccordionMultistep extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.accordions = this.querySelectorAll("details-accordion");
            customElements.whenDefined("details-accordion").then(()=>this.initialize());
        }
        initialize() {
            this.accordions.forEach((item)=>item.addEventListener("click", this.clickEvent.bind(this), false));
        }
        clickEvent(event) {
            if (event.target.localName !== "summary") return;
            this.switchAccordion(event.target.closest("details-accordion"), event);
        }
        switchAccordion(accordion, event) {
            this.scrollIntoView({
                behavior: "smooth"
            });
            this.accordions.forEach((item)=>item !== accordion && item.close());
            if (!event) accordion.open();
        }
    }
    customElements.define("details-accordion-multistep", DetailsAccordionMultistep);
}


/*
 * -----------------------------------------------------------------------------
 * @cam/details-accordion-multistep-cursor
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Procedural step collapsible accordions navigation.
 * @copyright 2022 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/details-accordion
 * @requires @cam/details-accordion-multistep
 * -----------------------------------------------------------------------------
*/ if (customElements.get("details-accordion-multistep-cursor") === undefined) {
    class DetailsAccordionMultistepCursor extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            customElements.whenDefined("details-accordion-multistep").then(()=>this.initialize());
        }
        initialize() {
            this.DetailsAccordionMultistep = this.closest("details-accordion-multistep");
            if (this.DetailsAccordionMultistep) this.hidden = false;
            this.accordions = this.DetailsAccordionMultistep.accordions;
            this.currentAccordion = this.DetailsAccordionMultistep.currentAccordion;
            this.nextButton = this.querySelector('button[name="next"]');
            this.previousButton = this.querySelector('button[name="previous"]');
            this.nextButton?.addEventListener("click", this.nextAccordion.bind(this));
            this.previousButton?.addEventListener("click", this.previousAccordion.bind(this));
            this.setButtonStates(this.getCurrentAccordionIndex());
        }
        getCurrentAccordionIndex() {
            const currentAccordion = this.DetailsAccordionMultistep.querySelectorAll("details[open]")[0]?.closest("details-accordion");
            if (!currentAccordion) return -1;
            return Array.from(this.accordions).indexOf(currentAccordion);
        }
        setButtonStates(index) {
            if (this.nextButton) this.nextButton.disabled = index + 1 >= this.accordions.length ? true : false;
            if (this.previousButton) this.previousButton.disabled = index <= 0 ? true : false;
        }
        nextAccordion() {
            const index = this.getCurrentAccordionIndex();
            this.DetailsAccordionMultistep.switchAccordion(this.accordions[index + 1]);
            this.setButtonStates(index + 1);
        }
        previousAccordion() {
            const index = this.getCurrentAccordionIndex();
            this.DetailsAccordionMultistep.switchAccordion(this.accordions[index - 1]);
            this.setButtonStates(index - 1);
        }
    }
    customElements.define("details-accordion-multistep-cursor", DetailsAccordionMultistepCursor);
}



})();
